import React from 'react'

import {
  GeneratorClientProposalContext,
  IGeneratorClientProposal,
} from './GeneratorClientProposalContext'

export function GeneratorClientProposalProvider({
  generatorClientProposalProps,
  children,
}: {
  generatorClientProposalProps: IGeneratorClientProposal
  children: React.ReactNode
}) {
  const context: IGeneratorClientProposal = generatorClientProposalProps

  return (
    <GeneratorClientProposalContext.Provider value={context}>
      {children}
    </GeneratorClientProposalContext.Provider>
  )
}
